import { Type } from "@angular/core";


import { AntecedentesPreviosComponent } from "../components/formulario/antecedentes-previos/antecedentes-previos.component";
import { PropiedadComponent } from "../components/formulario/propiedad/propiedad.component";
import { DeclaracionComponent } from "../components/formulario/declaracion/declaracion.component";
import { PropietarioComponent } from "../components/formulario/propietario/propietario.component";
import { PropietarioRepresentanteComponent } from "../components/formulario/propietario-representante/propietario-representante.component";
import { PersoneriaRepresentanteComponent } from "../components/formulario/personeria-representante/personeria-representante.component";
import { EmpresaComponent } from "../components/formulario/empresa/empresa.component";
import { ArquitectoComponent } from "../components/formulario/arquitecto/arquitecto.component";
import { CalculistaComponent } from "../components/formulario/calculista/calculista.component";
import { CalculistaResponsableComponent } from "../components/formulario/calculista-responsable/calculista-responsable.component";
import { ConstructoraComponent } from "../components/formulario/constructora/constructora.component";
import { ConstructorResponsableComponent } from "../components/formulario/constructor-responsable/constructor-responsable.component";
import { InspectorObraComponent } from "../components/formulario/inspector_obra/inspector_obra.component";
import { InspectorResponsableComponent } from "../components/formulario/inspector-responsable/inspector-responsable.component";
import { CuentaRevisorComponent } from "../components/formulario/cuenta-revisor/cuenta-revisor.component";
import { RevisorComponent } from "../components/formulario/revisor/revisor.component";
import { CuentaRevisorCalculoComponent } from "../components/formulario/cuenta-revisor-calculo/cuenta-revisor-calculo.component";
import { RevisorProyectoComponent } from "../components/formulario/revisor-proyecto/revisor-proyecto.component";
import { RevisorResponsableComponent } from "../components/formulario/revisor-responsable/revisor-responsable.component";
import { Caract_anteproyecto_obranuevaComponent } from "../components/formulario/caract_anteproyecto_obranueva/caract_anteproyecto_obranuevacomponent";
import { Superficie_anteproyectoComponent } from "../components/formulario/superficie_anteproyecto/superficie_anteproyecto.component";
import { SuperficieSubComponent } from "../components/formulario/superficie-sub/superficie-sub.component";
import { SuperficieSobreComponent } from "../components/formulario/superficie-sobre/superficie-sobre.component";
import { SuperficieDestinoComponent } from "../components/formulario/superficie-destino/superficie-destino.component";
import { Normas_urbanisticasComponent } from "../components/formulario/normas_urbanisticas/normas_urbanisticas.component";
import { ProteccionesEspecialesComponent } from "../components/formulario/protecciones-especiales/protecciones-especiales.component";
import { FormaCumplimientoComponent } from "../components/formulario/forma-cumplimiento/forma-cumplimiento.component";
import { PorcentajesObraNuevaComponent } from "../components/formulario/porcentajes-obra-nueva/porcentajes-obra-nueva.component";
import { CalculoAcumuladoCesionesComponent } from "../components/formulario/calculo-acumulado-cesiones/calculo-acumulado-cesiones.component";
import { PorcentajeFinalCesionComponent } from "../components/formulario/porcentaje-final-cesion/porcentaje-final-cesion.component";
import { CalculoAporteComponent } from "../components/formulario/calculo-aporte/calculo-aporte.component";
import { IncentivosNormativosComponent } from "../components/formulario/incentivos-normativos/incentivos-normativos.component";
import { Disposiciones_espComponent } from "../components/formulario/disposiciones_especiales/disposiciones_especiales.component";
import { AutorizacionesComponent } from "../components/formulario/autorizaciones/autorizaciones.component";
import { UnidadesComponent } from "../components/formulario/unidades/unidades.component";
import { clasificacionComponent } from "../components/formulario/clasificacion/clasificacion.component";
import { PermisosComponent } from "../components/formulario/permisos/permisos.component";
import { PermisosAnterioresComponent } from "../components/formulario/permisos-anteriores/permisos-anteriores.component";
import { OtrasSolicitudesAcompComponent } from "../components/formulario/otras-solicitudes-acomp/otras-solicitudes-acomp.component";
import { AntecedentesAdjuntanComponent } from "../components/formulario/antecedentes-adjuntan/antecedentes-adjuntan.component";
import { ArchivosComponent } from "../components/formulario/archivos/archivos.component";
import { ResumenComponent } from "../components/formulario/resumen/resumen.component";
import { UsoDeSueloComponent } from "../components/formulario/uso-de-suelo/uso-de-suelo.component";
import { ListadoPlanosComponent } from "../components/formulario/listado-planos/listado-planos.component";
import { ListadoDocumentosComponent } from "../components/formulario/listado-documentos/listado-documentos.component";
import { CaractAnteproyectoAntecedentesComponent } from "../components/formulario/caract-anteproyecto-antecedentes/caract-anteproyecto-antecedentes.component";
import { SuperficieViviendaComponent } from "../components/formulario/superficie-vivienda/superficie-vivienda.component";
import { ClasificacionModificarComponent } from "../components/formulario/clasificacion-modificar/clasificacion-modificar.component";
import { DeclaracionRecepcionComponent } from "../components/formulario/declaracion-recepcion/declaracion-recepcion.component";
import { Permisos_recepComponent } from "../components/formulario/permisos_recep/permisos_recep.component";
import { RepresentanteComponent } from "../components/formulario/representante/representante.component";
import { Tipo_proyectoComponent } from "../components/formulario/tipo_proyecto/tipo_proyecto.component";
import { ProyectosTipoComponent } from "../components/formulario/proyectos-tipo/proyectos-tipo.component";
import { CondicionesComponent } from "../components/formulario/condiciones/condiciones.component";
import { Permisos_recepcionesComponent } from "../components/formulario/permisos_recepciones/permisos_recepciones.component";
import { RecepcionesDefinitivasComponent } from "../components/formulario/recepciones-definitivas/recepciones-definitivas.component";
import { OtrasSolicitudesComponent } from "../components/formulario/otras-solicitudes/otras-solicitudes.component";
import { PermisoTramitadoComponent } from "../components/formulario/permiso-tramitado/permiso-tramitado.component";
import { PermisoRecepcionesComponent } from "../components/formulario/permiso-recepciones/permiso-recepciones.component";
import { CipComponent } from "../components/formulario/cip/cip.component";
import { Registro_bienesComponent } from "../components/formulario/registro_bienes/registro_bienes.component";
import { Permiso_notariadoComponent } from "../components/formulario/permiso_notariado/permiso_notariado.component";
import { Tipo_condominioComponent } from "../components/formulario/tipo_condominio/tipo_condominio.component";
import { Reglamento_copropiedadComponent } from "../components/formulario/reglamento_copropiedad/reglamento_copropiedadcomponent";
import { Tipo_autorizacionComponent } from "../components/formulario/tipo_autorizacion/tipo_autorizacion.component";
import { Profesional_compComponent } from "../components/formulario/profesional_comp/profesional_comp.component";
import { Permiso_demolicionComponent } from "../components/formulario/permiso_demolicion/permiso_demolicion.component";
import { NormasAgrupamientoComponent } from "../components/formulario/normas-agrupamiento/normas-agrupamiento.component";

import { Formulario111Component } from "../components/formulario/pdfForms/formulario111/formulario111.component";
import { Formulario112Component } from "../components/formulario/pdfForms/formulario112/formulario112.component";
import { Formulario113Component } from "../components/formulario/pdfForms/formulario113/formulario113.component";
import { Formulario114Component } from "../components/formulario/pdfForms/formulario114/formulario114.component";
import { Formulario115Component } from "../components/formulario/pdfForms/formulario115/formulario115.component";

import { Formulario131Component } from "../components/formulario/pdfForms/formulario131/formulario131.component";
import { Formulario132Component } from "../components/formulario/pdfForms/formulario132/formulario132.component";
import { Formulario133Component } from "../components/formulario/pdfForms/formulario133/formulario133.component";

import { Formulario151Component } from "../components/formulario/pdfForms/formulario151/formulario151.component";
import { Formulario152Component } from "../components/formulario/pdfForms/formulario152/formulario152.component";
import { Formulario153Component } from "../components/formulario/pdfForms/formulario153/formulario153.component";
import { Formulario154Component } from "../components/formulario/pdfForms/formulario154/formulario154.component";

import { Formulario211Component } from "../components/formulario/pdfForms/formulario211/formulario211.component";
import { Formulario212Component } from "../components/formulario/pdfForms/formulario212/formulario212.component";
import { Formulario213Component } from "../components/formulario/pdfForms/formulario213/formulario213.component";
import { Formulario214Component } from "../components/formulario/pdfForms/formulario214/formulario214.component";

import { Formulario231Component } from "../components/formulario/pdfForms/formulario231/formulario231.component";
import { Formulario232Component } from "../components/formulario/pdfForms/formulario232/formulario232.component";
import { Formulario233Component } from "../components/formulario/pdfForms/formulario233/formulario233.component";
import { Formulario234Component } from "../components/formulario/pdfForms/formulario234/formulario234.component";
import { Formulario235Component } from "../components/formulario/pdfForms/formulario235/formulario235.component";

import { Formulario251Component } from "../components/formulario/pdfForms/formulario251/formulario251.component";
import { Formulario252Component } from "../components/formulario/pdfForms/formulario252/formulario252.component";
import { Formulario253Component } from "../components/formulario/pdfForms/formulario253/formulario253.component";
import { Formulario254Component } from "../components/formulario/pdfForms/formulario254/formulario254.component";
import { Formulario255Component } from "../components/formulario/pdfForms/formulario255/formulario255.component";

import { Formulario271Component } from "../components/formulario/pdfForms/formulario271/formulario271.component";
import { Formulario272Component } from "../components/formulario/pdfForms/formulario272/formulario272.component";
import { Formulario273Component } from "../components/formulario/pdfForms/formulario273/formulario273.component";
import { Formulario274Component } from "../components/formulario/pdfForms/formulario274/formulario274.component";
import { Formulario275Component } from "../components/formulario/pdfForms/formulario275/formulario275.component";

import { Formulario56Component } from "../components/formulario/pdfForms/formulario56/formulario56.component";
import { Formulario58Component } from "../components/formulario/pdfForms/formulario58/formulario58.component";

import { Formulario1301Component } from "../components/formulario/pdfForms/formulario1301/formulario1301.component";
import { Formulario1303Component } from "../components/formulario/pdfForms/formulario1303/formulario1303.component";
export interface StepItem {
    component: Type<any>;
    title: string;
    required: boolean
    subTitle: string;
}

export interface Tab {
    header: number;
    title: string;
    content: StepItem[];
    valid: string[];
}

export interface WizardStep {
    name: string;
    tabs: Tab[];
}

export class AppSettings {
    public static forms: WizardStep[] = [
        {
            name: "1-1.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: true,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS",
                        },
                        {
                            required: true,
                            subTitle: "",
                            component: PropiedadComponent,
                            title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: true,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios", "informacionPropiedad", "propietarios"
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: true,
                            subTitle: "",
                            component: ArquitectoComponent,
                            title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent,
                            title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [
                        "arquitectos"
                    ],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "6.3 USO DE SUELO Y DESTINO (S) CONTEMPLADO (S) PERMISO ANTERIOR Y  EN LA AMPLIACIÓN"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.4   PROTECCIONES OFICIALES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.5 FORMA DE CUMPLIMIENTO ARTÍCULO 70° LGUC (*)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.6 CÁLCULO PRELIMINAR DEL PORCENTAJE DE CESIÓN DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN (Art. 2.2.5. Bis C. de la OGUC)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.9 CÁLCULO DEL  APORTE ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "6.14 CLASIFICACIÓN(ES)  CONSTRUCCIÓN(ES)   PREDOMINANTE(S) DE LA AMPLIACIÓN. Adjunte hoja adicional si requiere más líneas",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                            component: PermisosComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PermisosAnterioresComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES) (Excluyendo el original)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesAcompComponent,
                            title: "8 OTRAS SOLICITUDES QUE ACOMPAÑAN LA PRESENTE SOLICITUD",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "9 ANTECEDENTES QUE SE ADJUNTAN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario111Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-1.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características y superficie",
                    content: [
                        {
                            required: false,
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE OBRA MENOR - Modificación Edificaciones Existentes que no alteren su Estructura",
                            subTitle: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.2 SUPERFICIES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },

                {
                    header: 6,
                    title: "Protecciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.3 PROTECCIONES OFICIALES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.4 FORMA DE CUMPLIMIENTO ARTÍCULO 70° LGUC (*)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.5 CÁLCULO PRELIMINAR DEL PORCENTAJE DE CESIÓN DE LA MODIFICACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.6 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES) ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.7 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.8 CÁLCULO DEL  APORTE ",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Permisos",
                    content: [
                        {
                            required: false,
                            subTitle: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                            component: PermisosComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PermisosAnterioresComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES) (Excluyendo el original)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },

                {
                    header: 9,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "8 ANTECEDENTES QUE SE ADJUNTAN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario112Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 12,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-1.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características y superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN DE VIVIENDA SOCIAL Y OTRAS",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },

                {
                    header: 6,
                    title: "Normas y declaraciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 ÚNICAS NORMAS URBANÍSTICAS DE LOS PLANES REGULADORES CON LAS QUE DEBE CUMPLIR",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "6.4 CLASIFICACIÓN(ES)  CONSTRUCCIÓN(ES)   PREDOMINANTE(S). ",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Permisos",
                    content: [
                        {
                            required: false,
                            subTitle: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                            component: PermisosComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PermisosAnterioresComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES) (Excluyendo el original)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesAcompComponent,
                            title: "8 OTRAS SOLICITUDES QUE ACOMPAÑAN LA PRESENTE SOLICITUD",
                        },
                    ].filter(Boolean),
                    valid: [],
                },

                {
                    header: 8,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "9 ANTECEDENTES QUE SE ADJUNTAN (*)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario113Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 11,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-1.4",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características y superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS DE LA EDIFICACIÓN QUE SE REGULARIZA",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES EDIFICADAS",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },

                {
                    header: 6,
                    title: "Protecciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "6.3 USO DE SUELO Y DESTINO (S) CONTEMPLADO (S)  EN LA EDIFICACIÓN O AMPLIACIÓN QUE SE REGULARIZA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.4   PROTECCIONES OFICIALES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.5 DISPOSICIONES ESPECIALES A QUE SE ACOGE LA EDIFICACION QUE SE REGULARIZA",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "6.6 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "6.7 CLASIFICACIÓN(ES)  CONSTRUCCIÓN(ES)   PREDOMINANTE(S). Adjunte hoja adicional si requiere más líneas",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Permisos",
                    content: [
                        {
                            required: false,
                            subTitle: "7.1   PERMISO y RECEPCIÓN ORIGINAL",
                            component: PermisosComponent,
                            title: "7     PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PermisosAnterioresComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES) (Excluyendo el original)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "8 ANTECEDENTES QUE SE ADJUNTAN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario114Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 11,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-1.5",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "6.1 ANTECEDENTES GENERALES",
                            component: CaractAnteproyectoAntecedentesComponent,
                            title: "6 CARACTERÍSTICAS PROYECTO DE RADICACIÓN - INCISO SEGUNDO ARTÍCULO 6.2.9. OGUC",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieViviendaComponent,
                            title: "6.2 SUPERFICIE QUE SE REGULARIZA (En caso que se requiera regularizar vivienda existente)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.4 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.5 FORMA DE CUMPLIMIENTO ARTÍCULO 70° LGUC (*) ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.6 CÁLCULO PRELIMINAR DEL PORCENTAJE DE CESIÓN DE LA RADICACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES) (Art. 2.2.5. Bis C. de la OGUC)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.9 CÁLCULO DEL  APORTE ",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.10 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "6.11CLASIFICACIÓN(ES)  CONSTRUCCIÓN(ES)   PREDOMINANTE(S).",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                            component: PermisosComponent,
                            title: "7 CARACTERÍSTICAS  DE LA VIVIENDA ECONOMICA EXISTENTE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PermisosAnterioresComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES) (Excluyendo el original)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesAcompComponent,
                            title: "8 OTRAS SOLICITUDES QUE ACOMPAÑAN LA PRESENTE SOLICITUD",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "9 ANTECEDENTES QUE SE ADJUNTAN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario115Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 14,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-3.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR MODIFICADO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "6.3 USO DE SUELO Y DESTINO(S) CONTEMPLADO(S"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.4   PROTECCIONES OFICIALES: Predio o Inmueble  con Protección Oficial (información del CIP)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.5 FORMA DE CUMPLIMIENTO ARTÍCULO 70° LGUC (*) ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.6 CÁLCULO PRELIMINAR DEL PORCENTAJE DE CESIÓN DE LA AMPLIACIÓN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.9 CÁLCULO DEL  APORTE ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE  LA  MODIFICACIÓN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO  MODIFICADO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7 OTRAS SOLICITUDES QUE ACOMPAÑAN LA PRESENTE SOLICITUD ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesAcompComponent,
                            title: "8 ANTECEDENTES QUE SE ADJUNTAN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario131Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 15,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 16,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-3.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Clasificaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesAcompComponent,
                            title: "9.1 OTROS ANTECEDENTES (cuando corresponda)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario132Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 13,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-3.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "6.1 ANTECEDENTES GENERALES",
                            component: CaractAnteproyectoAntecedentesComponent,
                            title: "6 CARACTERÍSTICAS PROYECTO DE RADICACIÓN MODIFICADO - INCISO SEGUNDO ARTÍCULO 6.2.9. OGUC",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.2 SUPERFICIE QUE SE REGULARIZA (En caso que se requiera regularizar vivienda existente en la modificación)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieViviendaComponent,
                            title: "6.4 SUPERFICIES",
                        },

                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.5 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.6 FORMA DE CUMPLIMIENTO ARTÍCULO 70° LGUC (*)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.7 CÁLCULO PRELIMINAR DEL PORCENTAJE DE CESIÓN DE LA RADICACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title: "6.8 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES) ",
                        }
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Porcentaje",
                    content: [

                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN (Art. 2.2.5. Bis C. de la OGUC)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.9 CÁLCULO DEL  APORTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.10 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO  MODIFICADO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },

                {
                    header: 11,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "6.11CLASIFICACIÓN(ES)  CONSTRUCCIÓN(ES)   PREDOMINANTE(S). Adjunte hoja adicional si requiere más líneas",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "7 ANTECEDENTES QUE SE ADJUNTAN"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Formulario ",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: Formulario133Component, title: "Formulario"
                    }].filter(Boolean),
                    valid: [],
                },
                {
                    header: 15,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 16,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-5.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad y Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Calculista y constructor",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaraciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permisos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario151Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-5.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad y Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor y Insperctor ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisor y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RepresentanteComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Tipo Proyecto ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Tipo_proyectoComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permisos y Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario152Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-5.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad y Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Calculista y constructor",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaraciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permisos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario153Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "1-5.4",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad y Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor y Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaracion y Tipo Proyecto",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Tipo_proyectoComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CaractAnteproyectoAntecedentesComponent,
                            title: "CARACTERÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permisos y Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario154Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-1.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA COMPRADOR O PROMITENTE COMPRADOR",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO O PROMITENTE COMPRADOR",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Revisor",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 4,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "5 CARACTERÍSTICAS PRINCIPALES DEL ANTEPROYECTOOBRA NUEVA",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "5.1 SUPERFICIES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "5.2 NORMAS URBANÍSTICAS ",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "5.3 USO DE SUELO Y  DESTINO (S) CONTEMPLADO (S)"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "5.4 PROTECCIONES OFICIALES: Predio o Inmueble  con Protección Oficial (información del CIP).",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "5.5 FORMA DE CUMPLIMIENTO ARTÍCULO 70° LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "5.6 CÁLCULO DEL PORCENTAJE DE CESIÓN OBRA NUEVA",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "5.7 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL ANTEPROYECTO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "5.8 DISPOSICIONES ESPECIALES A QUE SE ACOGE O ACOGERÁ EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "5.9 AUTORIZACIONES ESPECIALES L.G.U.C",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "5.10 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ProyectosTipoComponent,
                            title: "5.11 PARA PROYECTOS CONDOMINIO TIPO B",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "5.12 CLASIFICACIÓN(ES)  CONSTRUCCIÓN(ES)   PREDOMINANTE(S). ",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CondicionesComponent,
                            title: "6 CONDICIONANTES DEL ANTEPROYECTO ",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "7 ANTECEDENTES QUE SE ADJUNTAN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario211Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 14,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-1.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Revisor",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Clasificación",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepcionesComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: RecepcionesDefinitivasComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario212Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 13,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-1.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Revisor",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepcionesComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: RecepcionesDefinitivasComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario213Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 13,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-1.4",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Revisor",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario214Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 13,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-3.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ProyectosTipoComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Tramitaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CondicionesComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PermisoTramitadoComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario231Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-3.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Clasificaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepcionesComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: RecepcionesDefinitivasComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario232Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-3.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Clasificaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Permisos_recepcionesComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: RecepcionesDefinitivasComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario233Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 14,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-3.4",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Clasificación",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario234Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 14,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-3.5",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Clasificaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario235Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 13,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-5.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ProyectosTipoComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario251Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-5.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: OtrasSolicitudesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario252Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-5.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario253Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-5.4",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: FormaCumplimientoComponent,
                            title: "6.8 PORCENTAJE FINAL DE CESIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAporteComponent,
                            title: "6.12 AUTORIZACIONES ESPECIALES LGUC",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Porcentaje",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajesObraNuevaComponent,
                            title: "6.9 CÁLCULO DEL APORTE (EN LOS CASOS QUE CORRESPONDA)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PorcentajeFinalCesionComponent,
                            title: "6.11 DISPOSICIONES ESPECIALES A QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculoAcumuladoCesionesComponent,
                            title:
                                "6.10 INCENTIVOS NORMATIVOS DEL IPT, A LOS QUE SE ACOGE EL PROYECTO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Disposiciones y autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario254Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-5.5",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionComponent,
                            title: "2 DECLARACIÓN JURADA DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Características",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Superficie",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Superficie_anteproyectoComponent,
                            title: "6.1 SUPERFICIES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSubComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieSobreComponent, title: ""
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: SuperficieDestinoComponent, title: ""
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Normas",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Normas_urbanisticasComponent,
                            title: "6.2 NORMAS URBANÍSTICAS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Uso de suelo",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: UsoDeSueloComponent, title: "USO DE SUELO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ProteccionesEspecialesComponent,
                            title:
                                "6.7 CÁLCULO ACUMULADO CON CESIONES O APORTES DE PERMISO(S) ANTERIOR(ES)",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Incentivos y disposiciones ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: IncentivosNormativosComponent,
                            title: "6.13 NÚMERO DE UNIDADES TOTALES POR DESTINO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Disposiciones_espComponent,
                            title:
                                "6.14 CLASIFICACIÓN(ES) CONSTRUCCIÓN(ES) PREDOMINANTE(S) DE LA AMPLIACIÓN",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Autorizaciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AutorizacionesComponent,
                            title: "7 PERMISO(S) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: UnidadesComponent,
                            title: "7.1 PERMISO y RECEPCIÓN ORIGINAL",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 10,
                    title: "Condiciones",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: clasificacionComponent,
                            title: "7.2 PERMISO(S) y RECEPCIÓN(ES) ANTERIOR(ES)",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 11,
                    title: "Listado",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoPlanosComponent, title: "LISTADO DE PLANOS"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ListadoDocumentosComponent,
                            title: "LISTADO DE DOCUMENTOS",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 12,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 13,
                    title: "Formulario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario255Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 14,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 15,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-7.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaración",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permiso y recepciones anteriores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PermisoRecepcionesComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario271Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-7.2",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaración",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permiso y recepciones anteriores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PermisoRecepcionesComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario272Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-7.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaración",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Caract_anteproyecto_obranuevaComponent,
                            title:
                                "6 CARACTERÍSTICAS PROYECTO DE AMPLIACIÓN CALIFICADO COMO OBRA MENOR",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permiso y recepciones anteriores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PermisoRecepcionesComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario273Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-7.4",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaración",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permiso y recepciones anteriores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PermisoRecepcionesComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario274Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "2-7.5",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad, Propietario y Representante",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesPreviosComponent,
                            title: "ANTECEDENTES PREVIOS :",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioRepresentanteComponent,
                            title: "REPRESENTANTE LEGAL DEL PROPIETARIO",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PersoneriaRepresentanteComponent,
                            title: "PERSONERÍA DEL REPRESENTANTE LEGAL",
                        },
                    ].filter(Boolean),
                    valid: [
                        "antecedentesPrevios",
                        "informacionPropiedad",
                        "propietarios",
                    ],
                },
                {
                    header: 2,
                    title: "Arquitecto y Calculista",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaComponent, title: "INFORMACIÓN DEL CALCULISTA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CalculistaResponsableComponent,
                            title: "INFORMACIÓN DEL CALCULISTA RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 3,
                    title: "Constructor e Inspector",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructoraComponent, title: "INFORMACIÓN DE LA CONSTRUCTORA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ConstructorResponsableComponent,
                            title: "INFORMACIÓN DEL CONSTRUCTOR RESPONSABLE",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorObraComponent, title: "INFORMACIÓN DEL INSPECTOR DE OBRA"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: InspectorResponsableComponent,
                            title: "INFORMACIÓN DEL INSPECTOR RESPONSABLE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Revisores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorComponent,
                            title: "5 PARTICIPACIÓN DE REVISORES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorComponent, title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: CuentaRevisorCalculoComponent,
                            title: "",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorProyectoComponent,
                            title: "INFORMACIÓN DEL REVISOR INDEPENDIENTE DE CÁLCULO ESTRUCTURAL",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RevisorResponsableComponent,
                            title: "INFORMACIÓN DEL PROFESIONAL COMPETENTE",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Declaración",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: DeclaracionRecepcionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Permiso y recepciones anteriores",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PermisoRecepcionesComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Formulario ",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario275Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 9,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 10,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "5.6",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Tipo_condominioComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Registro_bienesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["informacionPropiedad"],
                },
                {
                    header: 2,
                    title: "Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RepresentanteComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_notariadoComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["propietarios"],
                },
                {
                    header: 3,
                    title: "Arquitecto",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 4,
                    title: "Caracteristicas del Proyecto",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Reglamento_copropiedadComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Formulario 5.6",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario56Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 8,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "5.8",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Tipo_autorizacionComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: CipComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Registro_bienesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["informacionPropiedad"],
                },
                {
                    header: 2,
                    title: "Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RepresentanteComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_notariadoComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["propietarios"],
                },
                {
                    header: 3,
                    title: "Profesional Competente",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Profesional_compComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Permiso",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_demolicionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Formulario 5.8",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario58Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 9,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "8.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Tipo_autorizacionComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: CipComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Registro_bienesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 2,
                    title: "Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RepresentanteComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_notariadoComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 3,
                    title: "Profesional Competente",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Profesional_compComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 4,
                    title: "Permiso",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_demolicionComponent,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 5,
                    title: "Formulario 5.8",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario58Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 7,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "13.1",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Registro_bienesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["informacionPropiedad"],
                },
                {
                    header: 2,
                    title: "Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RepresentanteComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_notariadoComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["propietarios"],
                },
                {
                    header: 3,
                    title: "Profesional Competente",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: EmpresaComponent,
                            title: "4 DATOS PROFESIONALES RESPONSABLES",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                        },
                    ].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 4,
                    title: "Normas y Agrupamiento",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: NormasAgrupamientoComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Formulario 13.1",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario1301Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 9,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
        {
            name: "13.3",
            tabs: [
                {
                    header: 1,
                    title: "Propiedad",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropiedadComponent, title: "1 DATOS DE LA PROPIEDAD"
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: Registro_bienesComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["informacionPropiedad"],
                },
                {
                    header: 2,
                    title: "Propietario",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: PropietarioComponent,
                            title: "3 DATOS DEL PROPIETARIO",
                        },
                        {
                            required: false,
                            subTitle: "",
                            component: RepresentanteComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: Permiso_notariadoComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: ["propietarios"],
                },
                {
                    header: 3,
                    title: "Profesional Competente",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ArquitectoComponent, title: "INFORMACIÓN DEL ARQUITECTO"
                    }].filter(Boolean),
                    valid: ["arquitectos"],
                },
                {
                    header: 4,
                    title: "Normas y Agrupamiento",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: NormasAgrupamientoComponent,
                            title: "",
                        },
                        ,
                        {
                            required: false,
                            subTitle: "",
                            component: ClasificacionModificarComponent,
                            title: "",
                        },
                        ,
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 6,
                    title: "Antecedentes",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: AntecedentesAdjuntanComponent,
                            title: "10 MONTO A CONSIGNAR AL INGRESO",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 7,
                    title: "Formulario 13.3",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: Formulario1303Component,
                            title: "",
                        },
                    ].filter(Boolean),
                    valid: [],
                },
                {
                    header: 8,
                    title: "Documentos adjuntos",
                    content: [
                        {
                            required: false,
                            subTitle: "",
                            component: ArchivosComponent, title: "Documentos Adjuntos"
                        },
                    ].filter(Boolean),
                    valid: ["antecedentes", "archivos_marcados"],
                },
                {
                    header: 9,
                    title: "Resumen",
                    content: [{
                        required: false,
                        subTitle: "",
                        component: ResumenComponent, title: "RESUMEN"
                    }].filter(Boolean),
                    valid: [],
                },
            ],
        },
    ];
}
